<div class="login-screen">
    <div class="row w-100 m-0 align-login-card">

        <div class="offset-lg-1 col-xl-4 col-lg-6">
            <div class="card">
                <div class="card-body">
                    <img src="assets/images/logo.svg" class="m-auto d-table">
                    <h2 class="mt-4 mb-3 fw-medium">Reset Password</h2>
                    <p>Choose a new password that’s hard to guess and <br />unique to this account.</p>
                    <form [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPassForm()" novalidate>
                        <div class="row gy-3">
                            <div class="col-lg-12">
                                <label>New Password <span class="text-danger">*</span></label>
                                <mat-form-field class="w-100">
                                    <input matInput oninput="this.value = this.value.replace(/^\s+/g, '')" onpaste="return false" [type]="showNewPassword ? 'text' : 'password'" formControlName="NewPassword" placeholder="Enter new password" />
                                    <span (click)="togglePasswordVisibility('showNewPassword')" *ngIf="showNewPassword"><img src="../../../../assets/images/eye.svg"
                                            class="iconset"></span>
                                    <span (click)="togglePasswordVisibility('showNewPassword')" *ngIf="!showNewPassword"><img src="../../../../assets/images/eye-off.svg"
                                            class="iconset"></span>
                                </mat-form-field>
                                  <mat-error *ngIf="submitted && changePassControls['NewPassword'].hasError('required')">
                                    New password is required.
                                  </mat-error>
                                  <mat-error *ngIf="submitted && changePassControls['NewPassword'].hasError('pattern')">
                                    Password must be at least 8 characters long, and have a mixture of numbers, special characters,
                                    uppercase letters, lowercase letters, and without any space.
                                  </mat-error>
                            </div>
                            <div class="col-lg-12">
                                <label>Confirm New Password <span class="text-danger">*</span></label>
                                <mat-form-field class="w-100">
                                    <input matInput oninput="this.value = this.value.replace(/^\s+/g, '')" [type]="showConfirmPassword ? 'text' : 'password'" onpaste="return false" formControlName="ConfirmNewPassword" placeholder="Enter confirm new password" />

                                    <span (click)="togglePasswordVisibility('showConfirmPassword')" *ngIf="showConfirmPassword"><img src="../../../../assets/images/eye.svg"
                                            class="iconset"></span>
                                    <span (click)="togglePasswordVisibility('showConfirmPassword')" *ngIf="!showConfirmPassword"><img src="../../../../assets/images/eye-off.svg"
                                            class="iconset"></span>
                                </mat-form-field>
                                <mat-error *ngIf="submitted && changePassControls['ConfirmNewPassword'].hasError('required')">
                                    Confirm new password is required.
                                  </mat-error>
                                  <mat-error
                                    *ngIf="submitted && changePassControls['ConfirmNewPassword'].hasError('mismatch') && !changePassControls['ConfirmNewPassword'].hasError('required')">
                                    New password and confirm password do not match.
                                </mat-error>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-lg-12">
                                <app-recaptcha-widget #recaptchaWidget
                                    (resolved)="onCaptchaResolved()"
                                    (expired)="onCaptchaExpired()"></app-recaptcha-widget>
                            </div>
                            <div class="col-lg-12">
                                <button matButton="filled" type="submit" class="w-100 btn-primary"
                                    [disabled]="captchaService.isEnabled() && !isCaptchaVerified">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="col-lg-12">
                        <div class="d-flex justify-content-center align-items-center my-3">

                            <a type="submit" (click)="backToLogin()" class=" text-dark">
                                <i class="fa-solid fa-arrow-left me-2"></i>Back To Login</a>
                        </div>
                    </div>
                    <div class="card-footer border-0 mt-5">
                        <p class="m-0">
                            © {{year}} ALL RIGHTS RESERVED.
                            <a href="https://www.vaultx.com/" class="fw-medium text-primary" target="_blank">
                                <span>Collect</span>&nbsp;<span class="text-dark">X</span>

                            </a>
                        </p>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-xl-7">

        </div>
    </div>
</div>